<section class="main-section">
  <app-dialog-header title="Add Participants" (close)="cancel()"></app-dialog-header>
  <div class="input-field-section">
    <div class="input-box-full">
      <div class="input-label">Participants <span class="required">*</span></div>
      <div class="lead-section">
        <div class="field-dd type-dd" [class.open]="openDropdown === 'participantType'">
          <button type="button" class="field-dd-trigger" (click)="toggleDropdown('participantType')">
            <span>{{ getParticipantTypeLabel() }}</span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
          <div class="field-dd-panel" *ngIf="openDropdown === 'participantType'">
            <div class="field-dd-row" *ngFor="let item of type"
              [class.selected]="participantType === item.value" (click)="selectParticipantType(item.value)">
              {{ item.viewValue }}
            </div>
          </div>
        </div>
        <input type="text" class="custom-input contact-dd" placeholder="Search Participants" [(ngModel)]="searchText"
          (ngModelChange)="newFilterParticipants()">
      </div>
    </div>

    <div class="participant-list" *ngIf="filteredMailList?.length > 0; else emptyscreen">
      <label class="participant-row" *ngFor="let element of filteredMailList">
        <input type="checkbox" [checked]="selectedParticpants.hasOwnProperty(element.leadId)"
          (change)="addItem($event, element)">
        <div class="participant-info">
          <div class="participant-name">{{ element?.leadName | titlecase }}</div>
          <div class="participant-email">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="13" height="13"><path d="M4 4h16v16H4z" opacity="0"/><path d="M4 6h16v12H4z"/><path d="M4 6l8 7 8-7"/></svg>
            {{ element?.leadMail }}
          </div>
        </div>
      </label>
    </div>
    <ng-template #emptyscreen>
      <div class="empty-text">Oops, no participant found</div>
    </ng-template>

    <div class="input-box-full">
      <div class="input-label">Invite participants by email address</div>
      <textarea class="text-box" placeholder="Add email address" cols="30" rows="4" [(ngModel)]="particpantsMails"></textarea>
      <div class="field-hint">Use commas (",") to separate email addresses.</div>
    </div>
  </div>

  <app-dialog-footer
    [submitLabel]="'Add Participants'"
    [loading]="createLoader"
    (cancel)="cancel()"
    (submit)="addParticipants()">
  </app-dialog-footer>
</section>
